var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"detail"},[(_vm.detail.message.type==='ZZS')?_c('span',[_vm._v(" "+_vm._s(_vm.detail.message.data&&_vm.detail.message.data.tip||'未知')+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }